import { Location } from 'types';

export enum PortListVariant {
  CruiseCard = 'cruise-card',
  PricingPanel = 'pricing-panel'
}

export interface CruiseCardLocationListProps {
  title: string,
  locations: Array<Location>,
  variant: PortListVariant,
  packageId?: string
}